<style scoped>
.float-ads-wrapper {
    position: fixed;
    top: 50vh;
    left: 0;
    transform: translateY(-50%);
    z-index: 20;
    width: 100%;
    max-width: 100%;
    height: 100vh;
}

.image-container {
    max-width: calc(540 / 960 * 60vh);
}

.zoom-enter-active {
    animation-duration: 0.3s;
    animation-fill-mode: both;
    animation-name: zoom;
}

@keyframes zoom {
    from {
        opacity: 0;
        transform: scale(0.3, 0.3);
    }

    100% {
        opacity: 1;
    }
}

@screen sm {
    .float-ads-wrapper {
        width: calc(100vw * 1 / 4);
        height: auto;
        @apply p-2;
    }
}

@media all and (min-width: 75rem) {
    .float-ads-wrapper {
        width: calc(75rem * 1 / 4);
    }
}

/* calc(75rem + (75rem * 1 / 4) * 2) */
@media all and (min-width: 112.5rem) {
    .float-ads-wrapper {
        left: calc((100vw - 75rem) / 2 - (75rem * 1 / 4));
    }
}
</style>

<template>
    <transition name="zoom">
        <div class="float-ads-wrapper" v-if="show">
            <div class="absolute w-full h-full opacity-25 bg-white z-10"></div>
            <div class="flex flex-col justify-center h-full z-20 relative">
                <div class="bg-white">
                    <div>
                        <div class="image-container mx-auto">
                            <div
                                class="cursor-pointer"
                                @click="clickAdvrt(product)"
                            >
                                <productImage
                                    :product="product"
                                    :imageType="'advrt'"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-center mt-2">
                        <div
                            class="icon icon-scale rounded-full bg-red text-white cursor-pointer"
                            @click="closeAdvrt"
                        >
                            <closeSvg />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import productImage from './productImage.vue';
import closeSvg from '../assets/svg/close.svg';
import shuffle from 'lodash/shuffle';
import { marketingEventHandler } from '../utils/marketingDataProcessor';

const _localStorage_key = 'float_ads_last_close_timestamp_in_milli_second';

function getLastCloseTimestampMilliSecond() {
    try {
        return window.localStorage.getItem(_localStorage_key);
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error get last close timestamp');
    }

    return undefined;
}

function setLastCloseTimestampMilliSecond(val) {
    try {
        window.localStorage.setItem(_localStorage_key, val);
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error set last close timestamp');
    }
}

export default {
    components: {
        productImage,
        closeSvg
    },
    data() {
        return {
            show: false,
            product: undefined
        };
    },
    computed: {
        list() {
            return this.$store.getters.productAdvertisement;
        }
    },
    mounted() {
        const checkAndShowAdvrt = () => {
            if (this.getShouldShowAdvrt()) {
                this.showAdvrt();
            }
        };

        checkAndShowAdvrt();

        this.$watch('list', () => {
            checkAndShowAdvrt();
        });

        this.$watch('$route', () => {
            checkAndShowAdvrt();
        });
    },
    beforeDestroy() {
        if (this.showAdvrtTimeout) clearTimeout(this.showAdvrtTimeout);
    },
    methods: {
        getRandomProduct() {
            return shuffle(this.list)[0];
        },
        getCooldownMilliSecond() {
            if (window.innerWidth < 640) {
                return 5 * 60 * 1000;
            }
            return 1 * 60 * 1000;
        },
        getShouldShowAdvrt() {
            if (this.list.length === 0) {
                return false;
            }

            const lastCloseTimestampMilliSec = getLastCloseTimestampMilliSecond();
            const currentMilliSec = new Date().getTime();
            const cooldownMilliSec = this.getCooldownMilliSecond();

            return (
                !lastCloseTimestampMilliSec ||
                currentMilliSec - lastCloseTimestampMilliSec > cooldownMilliSec
            );
        },
        showAdvrt() {
            this.product = this.getRandomProduct();

            this.showAdvrtTimeout = setTimeout(() => {
                this.show = true;
                marketingEventHandler.advertisementDisplay(
                    this.product.prodKey,
                    this.product.shopListKey,
                    'FLOATING PRODUCT'
                );
            }, 5 * 1000);
        },
        clickAdvrt(product) {
            this.closeAdvrt();

            marketingEventHandler.advertisementClick(
                this.product.prodKey,
                this.product.shopListKey,
                'FLOATING PRODUCT'
            );

            this.$router.push(
                this.$store.getters.productDetailRoute(product.shopListProdKey)
            );
        },
        closeAdvrt() {
            setLastCloseTimestampMilliSecond(new Date().getTime());
            this.show = false;
        }
    }
};
</script>
